import { Component, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ThemeService } from './service/theme.service';
import { RestService } from './service/rest.service';
import { AlertComponent } from './components/message/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = '';
  sideBarOpen: boolean = true
  isLogin: boolean = window.location.pathname.includes('login') || window.location.pathname.includes('useractivate') || window.location.pathname.includes('forgot_password') || window.location.pathname.includes('user_reset')? true : false;
  isQrForm: boolean = window.location.pathname.includes('qr-form') ? true : false;

  constructor(private router: Router, public themeService: ThemeService, private restService: RestService,
    private dialog: MatDialog, private renderer: Renderer2,private titleService:Title) { 
    // const currentUrl = window.location.href;
    // const urlObj = new URL(currentUrl);
    // const domain = urlObj.origin;

    // console.log(domain);
    // this.restService.setBaseURL(domain); 
    //this.restService.setBaseURL('https://gda.innoyantra.com') 
    // this.restService.setBaseURL('https://uat-aki.innoyantra.com');
    this.getOrgTheme();
    }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.changeOfRoutes();
      }
    });
    setInterval(() => {
      this.isLogin = window.location.pathname.includes('login') || window.location.pathname.includes('useractivate') || window.location.pathname.includes('forgot_password') || window.location.pathname.includes('user_reset') ? true : false;
      this.isQrForm = window.location.pathname.includes('qr-form') ? true : false;
    }, 500 * 1)
  }

  sideBarToggler() {
    this.sideBarOpen = !this.sideBarOpen;
  }

  changeOfRoutes() {
    window.scrollTo(0, 0)
    this.isLogin = window.location.pathname.includes('login') || window.location.pathname.includes('useractivate') || window.location.pathname.includes('forgot_password') || window.location.pathname.includes('user_reset') ? true : false;
    this.isQrForm = window.location.pathname.includes('qr-form') ? true : false;
  }

  ngOnDestroy() {
    window.onbeforeunload = function () { window.scrollTo(0, 0); }
  }

  getOrgTheme() {
    // this.restService.postData(null, '/api/digital/core/Organization/GetOrgAppTheme', null, 'LoginUrl').subscribe((data: any) => {
      let data = {
        "rcode": 200,
        "rObj": {
            "orgAppTheme": "{\"iconColor\":\"#f15e55\",\"headerColor\":\"#f15e55\",\"buttonColor\":\"#f15e55\",\"secondaryColor\":\"#f15e55\",\"logoURL\":\"./assets/images/GDAConnct1.png\",\"dsbBackgroundURL\":\"./assets/images/newones.png\",\"dsbOverlayURL\":\"../../../assets/images/bglayout.png\",\"loginBackgroundURL\":\"https://01i327.n3cdn1.secureserver.net/wp-content/uploads/2022/06/scott-graham-5fNmWej4tAA-unsplash.jpg?time=1673988798\",\"favIcon\":\"./assets/images/favicon_GDA.png\",\"appTitle\":\"i3 Digital Connect\"}"
        },
        "isSuccess": false,
        "rmsg": [
            {
                "errorText": "SUCCESS",
                "errorCode": "SUCCESS",
                "fieldName": null,
                "fieldValue": null
            }
        ],
        "reqID": "f0926773-0ba2-47ab-968f-695334299631",
        "trnID": null
    }
      if (data.rcode == 200) {
        // this.loader.hide();
        let theme=JSON.parse(data.rObj.orgAppTheme);
        const root = document.documentElement;
        root.style.setProperty('--primary-color', theme?.iconColor);
        root.style.setProperty('--secondary-color', theme?.iconColor);
        root.style.setProperty('--tertiary-color', theme?.secondaryColor);
        this.themeService.setLogo(theme?.logoURL);
        this.themeService.setBg(theme?.dsbBackgroundURL);
        root.style.setProperty('--bglayout-image', `url('${theme?.dsbOverlayURL  }')`);
        root.style.setProperty('--loginbg-image', `url('${theme?.loginBackgroundURL  }')`);
        this.titleService.setTitle(theme?.appTitle);
        this.title=theme?.appTitle;
        const link = this.renderer.createElement('link');
        this.renderer.setAttribute(link, 'rel', 'icon');
        this.renderer.setAttribute(link, 'type', 'image/x-icon');
        this.renderer.setAttribute(link, 'href', theme?.favIcon);
      
        // Remove the existing favicon (optional)
        const existingFavicon = document.querySelector('link[rel="icon"]');
        if (existingFavicon) {
          this.renderer.removeChild(document.head, existingFavicon);
        }
      
        // Add the new favicon to the head element
        this.renderer.appendChild(document.head, link);
        // this.router.navigate(['/start-meeting']);
      } else if (data.rcode == 501) {
        // this.loader.hide();
        const dialogRef = this.dialog.open(AlertComponent, {
          width: '35vw',
          data: { data: data.rmsg[0]?.errorText, type: 'alert' }
        });
        dialogRef.afterClosed().subscribe();
      }
    // })
  }
}
